import { createClinicianMileageCap } from '../../../actions/areas/admin/commandActions';
import globals from '../../../globals/communityGlobals';
import _ from '../../../utils/lodash';
import { numberInRangeFrom0To99 } from '../../../settings/constants';

const locale = globals.getAreas(['mileageCap', 'error']);

export const eventHandlers = (state, setState, auth) => ({
  refreshTable: () => setState({ ...state, forceReload: !state.forceReload, mileageCapList: {} }),
  updateTableProps: (currentPage, pageSize) => setState({ ...state, currentPage, pageSize }),
  updateTableSort: (sortColumn, sortDirection) => setState({ ...state, sortColumn, sortDirection }),
  onFiltersChange: model =>
    setState({
      ...state,
      cliniciansBySurname: model.surname,
      orgUnitId: model.orgUnitId,
      currentPage: 1,
      mileageCapList: {},
    }),
  updateMileageCapValue: updateModel => {
    if (updateModel.mileageCap !== updateModel.oldMileageCap) {
      setState({ ...state, mileageCapList: { ...state.mileageCapList, [updateModel.clinicianId]: updateModel } });
    }
  },
  updateButtonText: 'Update MileageCap',
  handleUpdateEvent: () => {
    if (Object.keys(state.mileageCapList).length !== 0) {
      const updatedMileageCaps = Object.values(state.mileageCapList);
      const invalid = _.some(
        updatedMileageCaps,
        e => e.mileageCap === '' || !RegExp(numberInRangeFrom0To99).test(e.mileageCap),
      );

      if (invalid) {
        // eslint-disable-next-line no-alert
        alert(locale.getMsg('validationNumberRange', ['0-99']));
      } else {
        createClinicianMileageCap(auth, { ClinicianMileageCaps: updatedMileageCaps }, () =>
          setState({ ...state, mileageCapList: {}, forceReload: !state.forceReload }),
        );
      }
    }
  },
});
